// Mieterportal-Zugang – eine Stelle für Einheit-Seite (PortalKarte) und Mieter-Panel.
// Konto über kontoAnlegen (eigener Client, Sitzung des Verwalters bleibt), profiles-Eintrag
// (Rolle mieter, Aktiv) und mieter.profile_id, damit die Portal-Freigaben (my_mieter_ids) greifen.

import { supabase } from '../supabase/client';
import { kontoAnlegen } from '../auth/kontoAnlegen';

export async function gebePortalFrei(p: { name: string; email: string; passwort: string; mieterId?: string | null }): Promise<void> {
  const { data, error } = await kontoAnlegen({ email: p.email, password: p.passwort, data: { full_name: p.name, role: 'mieter' } });
  if (error) throw new Error(error.message);
  if (!data.user) throw new Error('Authentifizierung fehlgeschlagen.');
  const profil = await supabase.from('profiles').upsert({ id: data.user.id, full_name: p.name, email: p.email, role: 'mieter', status: 'Aktiv' }, { onConflict: 'id' });
  if (profil.error) throw new Error(profil.error.message);
  if (p.mieterId) {
    const m = await supabase.from('mieter').update({ profile_id: data.user.id }).eq('id', p.mieterId);
    if (m.error) throw new Error(`Zugang angelegt, aber nicht mit dem Mieter verknüpft: ${m.error.message}`);
  }
}

/** Sperren (Inaktiv) bzw. wieder freigeben (Aktiv) – wie bisher über E-Mail und Rolle. */
export async function setzePortalStatus(email: string, status: 'Aktiv' | 'Inaktiv'): Promise<void> {
  const { error } = await supabase.from('profiles').update({ status }).eq('email', email).eq('role', 'mieter');
  if (error) throw new Error(error.message);
}
